import Choices from "choices.js";

export default class Research {


	currentCategory = "0";
	selectedYear = "0";

	constructor() {
		const researchElements = document.getElementById("knowledge-research");
		if (!researchElements) {
			return;
		}

		this.init();
	}

	init() {
		const buttons = document.querySelectorAll(".cat-btn");

		buttons.forEach((button) => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				this.currentCategory = button.dataset.id;
				this.filterResearch();
				this.setActiveButton(button);
			});
		});

		const years = document.getElementById('year-filter');
		const yearsSelect = new Choices(years, {
			shouldSort: false,
			searchEnabled: false,
			itemSelectText: '',
		});

		yearsSelect.passedElement.element.addEventListener('change', (event) => {
			console.log(event.target.value);

			this.selectedYear = event.target.value;
			this.filterResearch();
		});

		const sectors = document.getElementById('sector-filter');
		const sectorsSelect = new Choices(sectors, {
			shouldSort: false,
			searchEnabled: false,
			itemSelectText: '',
		});

		sectorsSelect.passedElement.element.addEventListener('change', (event) => {
			const selectedSector = event.target.value;
			this.currentCategory = selectedSector;
			this.filterResearch();
			this.setActiveButton(document.querySelector(`.cat-btn[data-id="${selectedSector}"]`));
		});

	}

	filterResearch() {
		console.log("Filtering research with category:", this.currentCategory, this.selectedYear);
		const researchItems = document.querySelectorAll(".research-item");

		researchItems.forEach((item) => {
			if (this.currentCategory === "0" && this.selectedYear === "0") {
				item.classList.remove("hidden");
			} else {
				if (item.dataset.categories.includes(this.currentCategory) && (this.selectedYear === "0" || item.dataset.year === this.selectedYear)) {
					item.classList.remove("hidden");
				} else if (this.currentCategory === "0" && (this.selectedYear === "0" || item.dataset.year === this.selectedYear)) {
					item.classList.remove("hidden");
				} else {
					item.classList.add("hidden");
				}
			}
		});
	}

	setActiveButton(activeButton) {
		const buttons = document.querySelectorAll(".cat-btn");
		buttons.forEach((button) => {
			button.classList.remove("active");
		});
		activeButton.classList.add("active");
	}
}